import React from "react";
import GradientDef from "./GradientDef";

const AllGradients = props => (
  <React.Fragment>
    <GradientDef
      gradientId="purple"
      x2="1"
      y2="1"
      colorMap={[
        { offset: "0%", color: "#f4f4f4" },
        { offset: "100%", color: "#8785a2" }
      ]}
    />
    <GradientDef
      gradientId="red"
      x2="1"
      y2="1"
      colorMap={[
        { offset: "0%", color: "#f4f4f4" },
        { offset: "100%", color: "#f38181" }
      ]}
    />
    <GradientDef
      gradientId="blue"
      x2="1"
      y2="1"
      colorMap={[
        { offset: "0%", color: "#a1c4fd" },
        { offset: "100%", color: "#c2e9fb" }
      ]}
    />
    <GradientDef
      gradientId="greenishBlue"
      x2="1"
      y2="1"
      colorMap={[
        { offset: "0%", color: "#f4f4f4" },
        { offset: "100%", color: "#99ddcc" }
      ]}
    />
    <GradientDef
      gradientId="orange"
      x2="1"
      y2="1"
      colorMap={[
        { offset: "0%", color: "#f4f4f4" },
        { offset: "100%", color: "#FFBA8F" }
      ]}
    />
    <GradientDef
      gradientId="pink"
      x2="1"
      y2="1"
      colorMap={[
        { offset: "0%", color: "#f4f4f4" },
        { offset: "100%", color: "#FC91De" }
      ]}
    />
    <GradientDef
      gradientId="lightPink"
      x2="1"
      y2="1"
      colorMap={[
        { offset: "0%", color: "#a18cd1" },
        { offset: "100%", color: "#fbc2eb" }
      ]}
    />
    <GradientDef
      gradientId="Error"
      x2="1"
      y2="1"
      colorMap={[
        { offset: "0%", color: "#ff0844" },
        { offset: "100%", color: "#ffb199" }
      ]}
    />
  </React.Fragment>
);

export default AllGradients;
